// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class ControllerLabelsMessage implements flatbuffers.IUnpackableObject<ControllerLabelsMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ControllerLabelsMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsControllerLabelsMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ControllerLabelsMessage,
  ): ControllerLabelsMessage {
    return (obj || new ControllerLabelsMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsControllerLabelsMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ControllerLabelsMessage,
  ): ControllerLabelsMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ControllerLabelsMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  controllerLabels(): string;
  controllerLabels(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  controllerLabels(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startControllerLabelsMessage(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addControllerLabels(
    builder: flatbuffers.Builder,
    controllerLabelsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(0, controllerLabelsOffset, 0);
  }

  static endControllerLabelsMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // controller_labels
    return offset;
  }

  static createControllerLabelsMessage(
    builder: flatbuffers.Builder,
    controllerLabelsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ControllerLabelsMessage.startControllerLabelsMessage(builder);
    ControllerLabelsMessage.addControllerLabels(builder, controllerLabelsOffset);
    return ControllerLabelsMessage.endControllerLabelsMessage(builder);
  }

  unpack(): ControllerLabelsMessageT {
    return new ControllerLabelsMessageT(this.controllerLabels());
  }

  unpackTo(_o: ControllerLabelsMessageT): void {
    _o.controllerLabels = this.controllerLabels();
  }

  unpackFields(...fields: string[]): ControllerLabelsMessageT {
    const t = new ControllerLabelsMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("controller_labels")) {
      t.controllerLabels = this.controllerLabels();
    }
    return t;
  }
}

export class ControllerLabelsMessageT implements flatbuffers.IGeneratedObject {
  constructor(public controllerLabels: string | Uint8Array | null = null) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.controllerLabels === null || this.controllerLabels === undefined) {
      throw new Error('Required field "controller_labels" is not set');
    }
    const controllerLabels =
      this.controllerLabels !== null ? builder.createString(this.controllerLabels!) : 0;

    return ControllerLabelsMessage.createControllerLabelsMessage(builder, controllerLabels);
  }

  clone(): ControllerLabelsMessageT {
    const obj = new ControllerLabelsMessageT();
    obj.controllerLabels = this.controllerLabels;
    return obj;
  }

  equals(other: ControllerLabelsMessageT): boolean {
    if (this.controllerLabels !== other.controllerLabels) return false;
    return true;
  }
}

export function verifyControllerLabelsMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "controller_labels");
  } finally {
    verifier.popDepth();
  }
}
